import {cpfCnpj, cents} from '../../../filters/string'
import {beforeOneYear} from '../../../validators/date';
import * as F from '../../../filters/date';
import * as _ from 'lodash'
import moment from 'moment'
import Pagination, {
  Page
} from '../../../components/pagination';
import Tolls from '../../../services/toll';

export default {
  data() {
    return {
      loading: undefined,
      searchState: 'NEW',
      lastDays: '31',
      customStart: undefined,
      customEnd: undefined,
      dateRange: [this.customStart, this.customEnd],
      page: new Page(),
      vpFilterDate: {},
      summaryVP: {},
      origin: {},
      destination: {},
      open: true,
      totalValue: 0,
      lang: {
        formatLocale: {
          // MMMM
          months: ["Janeiro", "Fevereiro", "Março", "Abril", "Maio", "Junho", "Julho", "Agosto", "Setembro", "Outubro", "Novembro", "Dezembro"],
          // MMM
          monthsShort: ["Jan", "Fev", "Mar", "Abr", "Maio", "Jun", "Jul", "Ago", "Set", "Out", "Nov", "Dez"],
          // dddd
          weekdays: ["Domingo", "Segunda-feira", "Terça-feira", "Quarta-feira", "Quinta-feira", "Sexta-feira", "Sábado"],
          // ddd
          weekdaysShort: ["Dom", "Seg", "Ter", "Qua", "Qui", "Sex", "Sab"],
          // dd
          weekdaysMin: ["Dom", "Seg", "Ter", "Qua", "Qui", "Sex", "Sab"],
          // weekdaysMin: ["D", "S", "T", "Q", "Q", "S", "S"],
          // first day of week
          firstDayOfWeek: 0,
          // first week contains January 1st.
          firstWeekContainsDate: 1,
        },
      },
      momentFormat: {
        //[optional] Date to String
        stringify: (date) => {
          return date ? moment(date).format('L') : ''
        },
      },
    }
  },
  computed: {
    formatDate(date){
      
      return moment(date).format('L');
    },
    contractId() {
      return this.$route.params.vehicle.contractId;
    },
    vehicle() {
      return this.$route.params.vehicle;
    },
    periodStart() {
      let days = this.lastDays;
      let d = (this.customStart != undefined && this.customStart != null) ? moment(this.customStart) : moment().subtract(parseInt(days), 'd');

        return F.date(d, 'YYYY-MM-DD');
    },

    /** Calcula a data final do relatório **/
    periodEnd() {
      let days = this.lastDays;
      let d = (this.customEnd != undefined && this.customEnd != null) ? moment(this.customEnd) : moment();

      return F.date(d, 'YYYY-MM-DD');
    },
  },
  mounted: function() {
    this.doFilter();
    
  },
  created: function() {


  },
  methods: {
    handleChangeDate(value) {
      
      if (value.length > 1) {
        this.customStart = value[0];
        this.customEnd = value[1];
        this.lastDays = undefined;
      } else {
        this.customStart = undefined;
        this.customEnd = undefined;
        this.lastDays = value;
      }
      this.doFilter(true);
    },
    setCurrentPage(p) {
      this.page = this.page.page(p);
      this.doFilter();
    },
    setPageSize(size) {
      this.page = this.page.size(size);
      this.doFilter();
    },
    validate() {
      let error = this.errors;
      //this.searchState = 'NEW';
      let filter = {
        startDate: this.periodStart,
        endDate: this.periodEnd,
        // contratoOrig: this.contractId,
        placaVeiculo: this.vehicle.plate.replace('-', ''),
        page: this.page.build()
      };

      if (this.lastDays == undefined && (!this.customStart || !this.customEnd || (this.customStart > this.customEnd))) {
        this.searchState = 'ERROSEARCH';
        this.messageError = (this.customStart && this.customEnd) ? 'Impossível filtrar! O período inicial é mais novo que o período final.' : 'Existem campos não preenchidos!'
        return false;
      }

      if (this.lastDays == undefined && beforeOneYear.validate(moment(this.customStart).format("L"))) {
        this.searchState = 'ERROSEARCH';
        this.messageError = 'Período indisponível! Para consultas de período anteriores a um ano, favor entrar em contato com a nossa Central de Relacionamento.';
        return false;
      }

      if ( this.lastDays == undefined && this.customStart && this.customEnd  && ( (this.customEnd - this.customStart  ) > (2678400000) ) ) {
        //2678400000 = 31 dias
        this.searchState = 'ERROSEARCH';
        this.messageError = 'Período máximo permitido, 31 dias.';
         return false;
      }

      return filter;
    },
    doFilter(clearCache) {
      let filter = this.validate();

      if(clearCache) {
        this.totalValue = 0;
        this.summaryVP = {};
        filter.page = 1;
        this.page = filter.page = this.page.page(1);
      }
      
      if (filter) {
        let promise = Tolls.getFilter(filter).then(data => {
            this.summaryVP = data.itens;

            for(let i=0; i<this.summaryVP.length; i++) {
              this.$set(this.summaryVP[i], 'open', false);
              this.totalValue += this.summaryVP[i].valorVP;
            }

            if (data.total) {
              this.searchState = 'FOUND';
              this.page = this.page.itemCount(data.total);
              this.$nextTick(() => {
                $('[data-toggle="tooltip"]').tooltip();
                $('html, body').stop().animate({
                  scrollTop: $("#vp-vehicle-movement").offset().top - 110
                }, 1000);
              });
            } else {
              this.searchState = 'NOTFOUND';
            }
          })
          .catch(err => {
            this.searchState = 'NOTFOUND';
          });
        this.$store.dispatch('loading', promise);
      }
    }
  },
  components: {
    Pagination
  }
}



// WEBPACK FOOTER //
// ./src/pages/account/aggregate/vp-vehicle-movement.js